
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FloatingPlane() {
  const navigate = useNavigate();
  const [position, setPosition] = useState({ x: 20, y: 20 });
  const [direction, setDirection] = useState({ x: 1, y: 1 });
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile viewport
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Move the button around the screen
  useEffect(() => {
    const buttonSize = isMobile ? 32 : 64;
    const moveInterval = setInterval(() => {
      setPosition((prev) => {
        const newX = prev.x + direction.x * 0.5;
        const newY = prev.y + direction.y * 0.3;

        const maxX = window.innerWidth - buttonSize;
        const maxY = window.innerHeight - buttonSize;

        let newDirectionX = direction.x;
        let newDirectionY = direction.y;

        if (newX <= 0 || newX >= maxX) {
          newDirectionX = -direction.x;
        }
        if (newY <= 0 || newY >= maxY) {
          newDirectionY = -direction.y;
        }

        // Update direction only when it changes
        if (newDirectionX !== direction.x || newDirectionY !== direction.y) {
          setDirection({ x: newDirectionX, y: newDirectionY });
        }

        // Clamp position within bounds
        return {
          x: Math.max(0, Math.min(newX, maxX)),
          y: Math.max(0, Math.min(newY, maxY)),
        };
      });
    }, 50);

    return () => clearInterval(moveInterval);
  }, [direction, isMobile]);

  const handleClick = () => {
    navigate('/promocoes');
  };

  // Compute rotation based on horizontal direction
  const rotationDeg = direction.x > 0 ? 45 : -135;

  return (
    <button
      onClick={handleClick}
      className="fixed z-40 w-8 h-8 sm:w-16 sm:h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full shadow-2xl hover:shadow-amber-500/50 hover:scale-110 transition-all duration-300 flex items-center justify-center group cursor-pointer animate-pulse"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: `rotate(${rotationDeg}deg)`,
        transition: 'transform 0.3s ease',
      }}
      title="Clique para ver promoções!"
    >
      <i className="ri-plane-fill text-sm sm:text-3xl text-white group-hover:text-amber-100"></i>
      <div className="absolute -top-8 sm:-top-12 left-1/2 -translate-x-1/2 bg-slate-900 text-white px-2 py-0.5 sm:px-3 sm:py-1 rounded-lg text-[8px] sm:text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Ver Promoções! ✈️
      </div>
    </button>
  );
}
